// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }


// 授权网店列表
export function onlineStoreList(data) {
  return request({
    url: "/api/sale_auth/online_store_list",
    method: "post",
    data,
  });
}


// 授权网店详情
export function onlineStoreInfo(params) {
  return request({
    url: "/api/sale_auth/online_store_info",
    method: "get",
    params,
  });
}
